export default __webpack_public_path__ + "static/media/dashboardafterclick.cd767810.svg";